<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).on('click', '.currency__block', function(e) {
    $('.halo-top-currency').toggleClass('show');
}); 

$(document).on('click', function(event) {
    if ($('.top-language-currency').hasClass('show') && ($(event.target).closest('.top-language-currency').length === 0)) {
        $('.top-language-currency').removeClass('show');
    }
});
setTimeout(function(){
let showPopup = document.querySelectorAll(".letspop");
  //console.log(showPopup);

showPopup.forEach(function(popup){
    popup.addEventListener("click", function(){
      console.log(popup);
    let viewBtn = popup.previousElementSibling;
      //console.log(viewBtn);
    
      let figureDiv = document.getElementsByClassName("mfp-figure");
      //console.log(figureDiv);
      //figureDiv[0].innerHTML = "";
      figureDiv[0].innerHTML += viewBtn.innerHTML;
      
      let rightArrow = document.getElementsByClassName("mfp-arrow-right");
      rightArrow[0].addEventListener("click", function() {
        setTimeout(function(){
          let imgSrc = document.getElementsByClassName("mfp-img");
          imgSrc = imgSrc[0].src;
          //console.log(imgSrc);
          showPopup.forEach(function(link){
            let getLink = link.getElementsByTagName('a')[0].href;
            if (imgSrc == getLink){
              let designLink = link.previousElementSibling;
              designLink = designLink.getElementsByTagName('a')[0].href;
              figureDiv[0].getElementsByTagName('a')[0].href = designLink;
            }
          });
        }, 500);
      });
      let leftArrow = document.getElementsByClassName("mfp-arrow-left");
      leftArrow[0].addEventListener("click", function() {
        setTimeout(function(){
          let imgSrc = document.getElementsByClassName("mfp-img");
          imgSrc = imgSrc[0].src;
          //console.log(imgSrc);
          showPopup.forEach(function(link){
            let getLink = link.getElementsByTagName('a')[0].href;
            if (imgSrc == getLink){
              let designLink = link.previousElementSibling;
              designLink = designLink.getElementsByTagName('a')[0].href;
              figureDiv[0].getElementsByTagName('a')[0].href = designLink;
            }
          });
        }, 500);
      });
  });
  
});
  }, 1000);

var intervalId = window.setInterval(function(){
  $(".productView-price .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".productView-price .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".productView-price .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".productView-price .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".productView-price .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
    $(".prod_price .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".prod_price .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".prod_price .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".prod_price .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".prod_price .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
      $(".price .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".price .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
      $(".previewCartTotals-value .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".previewCartTotals-value .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".previewCartTotals-value .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".previewCartTotals-value .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".previewCartTotals-value .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".item-price .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".item-price .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".item-price .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".item-price .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".item-price .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".cart-total-value .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".cart-total-value .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".cart-total-value .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".cart-total-value .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".cart-total-value .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price-item .money:contains('USD')").html(function(_, html) {
   return html.split('USD').join("<span class='currencyAlpha'>USD</span>");
      $('span.currencyAlpha').remove();
  });
  $(".price-item .money:contains('EUR')").html(function(_, html) {
   return html.split('EUR').join("<span class='currencyAlpha'>EUR</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price-item .money:contains('GBP')").html(function(_, html) {
   return html.split('GBP').join("<span class='currencyAlpha'>GBP</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price-item .money:contains('CAD')").html(function(_, html) {
   return html.split('CAD').join("<span class='currencyAlpha'>CAD</span>");
    $('span.currencyAlpha').remove();
  });
  $(".price-item .money:contains('AUD')").html(function(_, html) {
   return html.split('AUD').join("<span class='currencyAlpha'>AUD</span>");
    $('span.currencyAlpha').remove();
  });
}, 500);


/* Judge.me — restore the configured sort on the empty-state fallback.

   On a product with no reviews of its own, Judge.me swaps the list for
   "Reviews for other products" and hard-codes that list to Most recent,
   ignoring the default sort set in the app. Verified: a 55-review product
   mounts with sort `highest_rating`, a 0-review product mounts with
   `created_at` and renders 4/5/4/3 stars. There is no app setting for the
   fallback's order, so it is corrected here.

   Deliberately narrow:
   - Only acts when the fallback list is actually on screen AND the control
     mounted on `created_at`. A product with its own reviews already mounts on
     `highest_rating`, so nothing fires and there is no second fetch.
   - One shot. A real (trusted) change event from the shopper cancels it for
     good, so a manual sort choice is never overridden.

   NOTE: WANTED must be kept in step with the app's default sort. If the
   default is ever changed away from Highest rating, change it here too or
   this will quietly fight the new setting. */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var WANTED = 'highest_rating';
  var GIVE_UP_AFTER = 20000;
  var POLL = 300;
  var done = false;

  // The shopper picking a sort themselves wins outright. Their event is
  // trusted; the one dispatched below is not, so the two never collide.
  document.addEventListener('change', function (e) {
    if (e.isTrusted && e.target && e.target.className &&
        String(e.target.className).indexOf('jdgm-sort-dropdown') !== -1) {
      done = true;
    }
  }, true);

  // Judge.me labels the fallback list with a purpose-named class, which is a
  // far steadier hook than the heading text. The text sweep is only a fallback
  // in case that class is ever renamed — and it must not assume a heading tag:
  // the label is a <p class="jm-text jm-other-products-reviews-text">.
  function fallbackIsShowing(widget) {
    if (widget.querySelector('.jm-other-products-reviews-text')) return true;
    var nodes = widget.querySelectorAll('p, h1, h2, h3, h4, [class*="other-products"]');
    for (var i = 0; i < nodes.length; i++) {
      if (/reviews for other products/i.test(nodes[i].textContent || '')) return true;
    }
    return false;
  }

  function hasOption(sel, value) {
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === value) return true;
    }
    return false;
  }

  function attempt(waited) {
    if (done) return;
    var widget = document.querySelector('.jdgm-widget.jdgm-review-widget');
    var sel = widget && widget.querySelector('select.jdgm-sort-dropdown');

    if (sel) {
      done = true;
      if (sel.value === 'created_at' && fallbackIsShowing(widget) && hasOption(sel, WANTED)) {
        sel.value = WANTED;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    if (waited >= GIVE_UP_AFTER) return;
    setTimeout(function () { attempt(waited + POLL); }, POLL);
  }

  if (document.readyState === 'complete') { attempt(0); }
  else { window.addEventListener('load', function () { attempt(0); }); }
})();


/* Happy Customers page — reveal one extra batch of reviews on load.

   Judge.me's "Reviews per page" caps at 15 in the app, and the page opens with
   a single batch behind a "Show more" button. One programmatic click doubles
   what is visible before the shopper has to act.

   Cheap to do: the button does NOT fetch. The reviews are already in the page
   and it only reveals the next slice, so this costs no extra request — just a
   taller first paint.

   Narrow on purpose:
   - Keyed to .jdgm-all-reviews-widget*, so it never touches the product page's
     review widget (a different class).
   - Fires only while aria-expanded is "false", the untouched initial state, so
     a re-render cannot re-trigger it and it stops after exactly one batch.
   - A real (trusted) click from the shopper stands it down for good.
   - Selector and aria state are language-independent; matching the words
     "Show more" would break on a translated storefront. */
(function () {
  var GIVE_UP_AFTER = 20000;
  var POLL = 300;
  var done = false;

  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target && e.target.closest &&
        e.target.closest('.jdgm-masonry-grid__btn')) {
      done = true;
    }
  }, true);

  function attempt(waited) {
    if (done) return;
    var widget = document.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-all-reviews-widget');
    if (widget) {
      var btn = widget.querySelector('button.jdgm-masonry-grid__btn');
      if (btn) {
        done = true;
        if (btn.getAttribute('aria-expanded') === 'false') { btn.click(); }
        return;
      }
    }
    if (waited >= GIVE_UP_AFTER) return;
    setTimeout(function () { attempt(waited + POLL); }, POLL);
  }

  if (document.readyState === 'complete') { attempt(0); }
  else { window.addEventListener('load', function () { attempt(0); }); }
})();


/* Lookbook hotspot card — keep it pinned to its hotspot.

   theme.js's doAjaxAddLookbookModal reads the pin's document offset ONCE when
   the card opens and writes absolute left/top onto .halo-lookbook-popup, which
   lives at <body> level. Nothing recalculates, so anything that shifts the
   layout — opening the cart drawer above all — moves the pin while the card
   stays put and the leader line stretches across the gap.

   Approach: translate the card by exactly the delta the pin moved, rather than
   recomputing the theme's placement formula. Two reasons that is better here:

   1. The leader line stays correct for free. Moving both by the same delta
      preserves the gap the elbow was drawn for, so --lb-run needs no update.
      That matters because setLookbookLeaderLine lives on theme.js's internal
      `halo` object, which is NOT exposed on window — it cannot be called from
      here at all.
   2. It does not depend on the theme's own maths, including the quirk where
      the card is centred vertically using the modal's WIDTH.

   The pin is captured on click. The theme does not mark the open pin with an
   .active class — an earlier version of this relied on that and silently did
   nothing, every frame. */
(function () {
  var OPEN_CLASS = 'popup-lookbook-product-style-1';
  var POPUP_SEL = '.halo-lookbook-popup.style-1';
  var pinEl = null, basePin = null, baseCard = null, timer = null;
  var lastDx = 0, lastDy = 0;
  var CHECK_MS = 100;
  var raf = null, burstUntil = 0;
  var BURST_MS = 600;   // long enough to cover the cart drawer's open/close

  function docPos(el) {
    var r = el.getBoundingClientRect();
    return { x: r.left + window.pageXOffset, y: r.top + window.pageYOffset };
  }

  // Capture phase: record which hotspot opened the card, before the theme's
  // own handlers run.
  document.addEventListener('click', function (e) {
    var p = e.target && e.target.closest ? e.target.closest('[data-lookbook-icon]') : null;
    if (p) { pinEl = p; basePin = null; baseCard = null; }
  }, true);

  // setInterval rather than requestAnimationFrame as the baseline on purpose:
  // rAF is paused entirely while the page is hidden (backgrounded tab,
  // prerender), so a card left open across a visibility change would stop
  // tracking. The timer only exists while the card is open.
  //
  // 100ms is fine for a card sitting still, but not for the moment the layout
  // actually moves: opening the cart drawer shifts the pin in one frame, and a
  // correction up to 100ms later reads as the card snapping across after it.
  // So a body class change (which is what the drawer toggles) also starts a
  // short burst of frame-aligned updates — see the observer below.
  function tick() {
    if (!document.body.classList.contains(OPEN_CLASS)) {
      clearInterval(timer); timer = null; basePin = null; baseCard = null;
      lastDx = 0; lastDy = 0;
      return;
    }
    var popup = document.querySelector(POPUP_SEL);
    if (popup && pinEl && document.contains(pinEl)) {
      var p = docPos(pinEl);
      if (!basePin) {
        // First tick after opening: remember where both started.
        //
        // baseCard reads the card's COMPUTED top/left, not its rendered rect.
        // The card carries margin-top: 211px (custom.css). A rendered rect
        // includes that margin, but writing the same number back into `top`
        // makes the browser apply the margin again on top of it — the card
        // drifts down by the margin on the first correction. Computed top/left
        // are the positioning values, so a round trip is lossless.
        basePin = p;
        var cs = window.getComputedStyle(popup);
        baseCard = { x: parseFloat(cs.left) || 0, y: parseFloat(cs.top) || 0 };
      } else {
        var dx = p.x - basePin.x, dy = p.y - basePin.y;
        // Compare against the delta last APPLIED, not against zero. Skipping
        // when dx/dy are zero looks like a harmless optimisation but strands
        // the card: closing the cart drawer returns the pin to its original
        // spot, delta goes back to 0, the write is skipped and the card keeps
        // the offset it was given on the way out.
        if (dx !== lastDx || dy !== lastDy) {
          lastDx = dx; lastDy = dy;
          // Always derived from the recorded base, never from the card's
          // current position, so repeated shifts cannot accumulate drift.
          popup.style.left = (baseCard.x + dx) + 'px';
          popup.style.top = (baseCard.y + dy) + 'px';
        }
      }
    }
  }

  // One update per painted frame, for as long as the layout is likely to still
  // be moving. Self-terminating: no loop survives the card closing.
  function frame() {
    tick();
    if (Date.now() < burstUntil && document.body.classList.contains(OPEN_CLASS)) {
      raf = window.requestAnimationFrame(frame);
    } else {
      raf = null;
    }
  }

  new MutationObserver(function () {
    if (!document.body.classList.contains(OPEN_CLASS)) { return; }
    if (timer === null) {
      basePin = null; baseCard = null; lastDx = 0; lastDy = 0;
      timer = setInterval(tick, CHECK_MS);
    }
    // Reached on the card opening AND on every later body class change while
    // it stays open — opening or closing the cart drawer is one of those.
    burstUntil = Date.now() + BURST_MS;
    if (raf === null && window.requestAnimationFrame) { raf = window.requestAnimationFrame(frame); }
    tick();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();


/* "Customers are saying" header -> /pages/happy-customers.

   Judge.me renders .jdgm-header (the h2 plus the rating line) client-side, so
   there is no Liquid to wrap and no markup at first paint. This wraps both in a
   real anchor once they exist.

   A real <a>, not a click listener: keyboard users can tab to it, it shows the
   destination on hover, and cmd/middle-click open a new tab — none of which a
   handler on a <div> gives you.

   Idempotent and observed, because the widget re-renders its header on carousel
   init and on some resizes; without the guard each pass would nest another
   anchor, and without the observer the link would silently vanish. */
(function () {
  var HREF = '/pages/happy-customers';
  var WIDGET = '.jdgm-cards-carousel';
  var LINK_CLASS = 'jdgm-header-link';

  function wrap() {
    var headers = document.querySelectorAll(WIDGET + ' .jdgm-header');
    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      if (header.querySelector('.' + LINK_CLASS)) { continue; }   // already done
      if (!header.querySelector('.jdgm-title')) { continue; }     // not populated yet

      var a = document.createElement('a');
      a.className = LINK_CLASS;
      a.setAttribute('href', HREF);
      a.setAttribute('aria-label', 'Read all customer reviews');
      while (header.firstChild) { a.appendChild(header.firstChild); }
      header.appendChild(a);
    }
  }

  function start() {
    wrap();
    var root = document.querySelector(WIDGET) || document.body;
    new MutationObserver(wrap).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete') { start(); }
  else { window.addEventListener('load', start); }
})();


/* Header account icon -> the hosted customer account page.

   The store moved to Shopify's customer accounts (the passwordless page at
   account.coloritto.co), but the header icon never navigated anywhere: Halo
   renders it as <a class="header__icon header__icon--account"
   data-open-auth-sidebar> with NO href, and two separate handlers open the
   theme's own auth sidebar instead —
     snippets/halo-customer-login-sidebar.liquid  jQuery .click() on the class
     assets/halo-customer-login.js:20             listener on the attribute
   That sidebar still contains the legacy email+password form, so pressing the
   icon showed the old login window even though /account/login itself already
   redirects correctly.

   Fix: give the icon a real href and stop the sidebar handlers from firing.
   /account covers both states — Shopify sends a signed-out visitor to the
   hosted sign-in page and a signed-in one to their account.

   The listener is registered in the CAPTURE phase precisely so it runs before
   the two handlers above, which are bound at target/bubble. It only stops
   propagation; it never calls preventDefault, so the browser still follows the
   href. Removing the data attribute is not enough on its own — halo-customer-
   login.js has already bound by then, and unbinding jQuery handlers from here
   would mean reaching into the theme's own script. */
(function () {
  var ICON = 'a.header__icon--account';

  // Keep any locale prefix (/en-gb/account), otherwise the link drops the
  // shopper's language on multi-locale stores.
  function accountUrl() {
    var first = window.location.pathname.split('/')[1] || '';
    return /^[a-z]{2}(-[a-z]{2})?$/i.test(first) ? '/' + first + '/account' : '/account';
  }

  function link() {
    var icons = document.querySelectorAll(ICON);
    for (var i = 0; i < icons.length; i++) {
      var a = icons[i];
      if (a.dataset.acctLinked === '1') { continue; }
      a.dataset.acctLinked = '1';
      a.setAttribute('href', accountUrl());
      a.removeAttribute('data-open-auth-sidebar');
      a.addEventListener('click', function (e) { e.stopImmediatePropagation(); }, true);
    }
  }

  function start() {
    link();
    // The header re-renders on sticky/mobile breakpoints, which replaces the
    // icon node and drops the listener with it.
    new MutationObserver(link).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
